export type JRpcErrorStruct = {
    message: string,
    code: number,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any
};

export type CustomJrpcErrResult = {
    error: JRpcErrorStruct
}


export class JRpcErrResponse {
    public jsonrpc: '2.0';
    public error: JRpcErrorStruct;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public id?: any;

    constructor(error: JRpcErrorStruct) {
        this.error = error;
    }
}
